  /**
  * @description: 公共接口函数
  * @author: lzc
  * @createTime: lzc(2021-7-25)
  * @updateTime: name(xxxx-xx-xx)
  */
 //引入token刷新API访问接口
 import API_ADMIN from "../api/api_user";
 import router from '../router'

 import { Message } from 'element-ui';
 import { Loading } from 'element-ui';

//用于判断访问token是否刷新，不能少
window.isReresh = false;

var SIGN_REGEXP = /([yMdhsm])(\1*)/g
var DEFAULT_PATTERN = 'yyyy-MM-dd'
function padding (s, len) {
  let l = len - (s + '').length
  for (var i = 0; i < l; i++) { s = '0' + s }
  return s
};

//这里是封装的公钥
const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCzoY/zEvgAZMsICE2K25paLulLaRqt2J6mO6+/c7Kr7HifLDSiJBorxsbndRUpyimBrmwNdXDffXWZ/Fs5TtvrVZ7uDs9Z6/r6l0IYCFlSDnvLVBEOw1kn1dSY/7kqAYMKuSWd7IhusbrDC1jnUeo23ySmRzKvQ5hirck0SO1JswIDAQAB';
//这里是封装的私钥
const privateKey = 'MIICeAIBADANBgkqhkiG9w0BAQEFAASCAmIwggJeAgEAAoGBALOhj/MS+ABkywgITYrbmlou6UtpGq3YnqY7r79zsqvseJ8sNKIkGivGxud1FSnKKYGubA11cN99dZn8WzlO2+tVnu4Oz1nr+vqXQhgIWVIOe8tUEQ7DWSfV1Jj/uSoBgwq5JZ3siG6xusMLWOdR6jbfJKZHMq9DmGKtyTRI7UmzAgMBAAECgYAphlmuiV4HSUWeD71NMkLWQi3wHtXqBj92kimoimhtUfb4ZNGuAcaDBCqK6wf/Zxp9PgMAgXucTnZXKH02HEK+GsLdwIOrzFR6vEkkMOWWNmTSJWZS+ZreW/dxETqgN8TUvFpbKZn6n0t6DoQ52CjGsyTuv6MqYegSP1RgFx6CEQJBAOnKot1JatjY281qdcVVflVj9FFKz1HkYMz88yNdxBegbm06QkcaeS3vejycNyEVzuLDvHJBPZlWGnOxwShoozUCQQDEsdj5vJwKGvAJWI4efGPk+dIKCE+716nSO37qyvdLb0rLv7PaVXQf5Kz6KMsnJ1v9Zg1XU8EiOY9xpAO2Uq5HAkEAkxLS2fqxqLDjtZnfdMCPtRAoRmuVeKL+8nW+TuVR0rsuPLCFuU1CJk+cyjxLwhiCCc2w4v9/zNKJ2XZdWRpacQJBAMJRVSL700gkbqk9BEJX7zRiHb/tkB/qIopgXrVEyOSMUV9SxzLWoz9y4fTN4k2PE9EWRe3U/4N5TB4fw88WhbcCQQDFQVNjAGZmOERdrMQHjC5rc6Ew/iqfQE1FW4cw5qho+SHQ4gQW3vkPDaawisoKCQ26vkJzYvJUHmyKewjG06YL';

export default {
  getQueryStringByName: function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    var r = window.location.search.substr(1).match(reg)
    var context = ''
    if (r != null) { context = r[2] }
    reg = null
    r = null
    return context === null || context === '' || context === 'undefined' ? '' : context
  },
  formatDate: {

    format: function (date, pattern) {
      pattern = pattern || DEFAULT_PATTERN
      return pattern.replace(SIGN_REGEXP, function ($0) {
        switch ($0.charAt(0)) {
          case 'y': return padding(date.getFullYear(), $0.length)
          case 'M': return padding(date.getMonth() + 1, $0.length)
          case 'd': return padding(date.getDate(), $0.length)
          case 'w': return date.getDay() + 1
          case 'h': return padding(date.getHours(), $0.length)
          case 'm': return padding(date.getMinutes(), $0.length)
          case 's': return padding(date.getSeconds(), $0.length)
        }
      })
    },
    parse: function (dateString, pattern) {
      var matchs1 = pattern.match(SIGN_REGEXP)
      var matchs2 = dateString.match(/(\d)+/g)
      if (matchs1.length === matchs2.length) {
        var _date = new Date(1970, 0, 1)
        for (var i = 0; i < matchs1.length; i++) {
          var _int = parseInt(matchs2[i])
          var sign = matchs1[i]
          switch (sign.charAt(0)) {
            case 'y': _date.setFullYear(_int); break
            case 'M': _date.setMonth(_int - 1); break
            case 'd': _date.setDate(_int); break
            case 'h': _date.setHours(_int); break
            case 'm': _date.setMinutes(_int); break
            case 's': _date.setSeconds(_int); break
          }
        }
        return _date
      }
      return null
    }
 },

 //获取数组或者对象长度
 getLength: function(data) {
  var len = 0;
  var t = typeof data;
  if (t == "string") {
    len = data.length;
  } else if (t == "object") {
    for (var i in data) {
      len++;
    }
  }
  return len;
},

//IP地址验证
regIp: function(ip) {
  var str =/^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
  return str.test(ip);
},

 rsaCrypt: {
 /**
  * @description: RSA加密算法是最常用的非对称加密算法，它既能用于加密，也能用于数字签名
  *               提供RSA加解密调用接口
  * @author: lzc
  * @createTime: lzc(2021-10-29)
  * @updateTime: name(xxxx-xx-xx)
  */

  //加密方法
  rsaEncrypt(pas){
    //实例化jsEncrypt对象
    let jse = new JSEncrypt();
    //设置公钥
    jse.setPublicKey(publicKey);
    //console.log('加密：'+jse.encrypt(pas))
    return jse.encrypt(pas);
  },
  
  //解密方法
  rsaDecrypt(pas){
    let jse = new JSEncrypt();
    //设置私钥
    jse.setPrivateKey(privateKey)
    //console.log('解密：'+jse.decrypt(pas))
    return jse.decrypt(pas);
  },

 },

// 刷新token
getRefreshToken: function (param) {
  let params = {
    refreshToken:param
  }
  //通过刷新token重新获取访问token
  console.log('.......getRefreshToken');
  return API_ADMIN.tokenRefresh(params)
    .then((res) => {
      return Promise.resolve(res)
    })
},

// 计算访问token过期时间
isRefreshTokenExpired: function (expiresIn) {
  let that = this;
  clearInterval(window.interval);
  window.interval = setInterval(()=>{
    expiresIn=expiresIn-1;
    sessionStorage.setItem('expiresIn',expiresIn);
    // console.log('.......isRefreshTokenExpired expiresIn:' + expiresIn);
    //提前4分钟进行访问token刷新
    if(expiresIn<10){
      if(!window.isReresh){
        window.isReresh = true;
        let refreshToken = sessionStorage.getItem('refreshToken');
        //console.log('.......getRefreshToken begin');
        that.getRefreshToken(refreshToken).then(res => {
          window.isReresh = false;
          //console.log('.......tokenRefresh:' + JSON.stringify(res));
          if (0 === res.errorCode) {
            //将更新的访问token、token有效时间保持 JSON.stringify
            console.log("..........accessToken refresh ok:" + res.accessToken);
            sessionStorage.setItem("accessToken", res.accessToken);
            //expiresIn时间单位为s
            sessionStorage.setItem("expiresIn", res.expiresIn);
            //重新开始新的定时
            expiresIn = res.expiresIn;
          }else{
            console.log("..........getRefreshToken error！");
            //刷新失败返回登录页面
            clearInterval(window.interval);
            Message({
              showClose: true,
              type: "error",
              message: "RefreshToken错误，重新登陆！",
              duration: 10000
            });
            //刷新失败返回登录页面
            router.push('/login');
          }
        })
        .catch(e => {
          window.isReresh = false;
          Message({
            showClose: true,
            type: "error",
            message: "刷新token请求出现异常",
            duration: 2000
          });
          //刷新失败返回登录页面
          clearInterval(window.interval);
          router.push('/login');
        });
      }
      
    }
  },1000)
},


// 在此添加新的全局函数

}



// WEBPACK FOOTER //
// ./src/common/util.js